import { takeEvery, call, put } from "redux-saga/effects";
import * as types from "../constants";

import * as Service from "./service";
import * as Notification from "./notification-saga";

export function* changeAppStatusSaga(actions) {
  const response = yield call(Service.changeStatusService, actions.status);

  if (response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      payload: { res: 1, status: actions.status },
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      payload: { res: 2, status: actions.status },
    });
  }
}

export function* getListProductReviews(actions) {
  const response = yield call(
    Service.getListProductReviews,
    actions.status_rev,
    actions.review_rating,
    actions.review_title_like,
    actions.page,
    actions.filter_hidden,
    actions.filter_media,
  );

  if (response) {
    yield put({
      type: types.GET_LIST_REVIEW_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListReviewCustomerSay(actions) {
  const response = yield call(
    Service.getListProductReviews,
    actions.status_rev,
    actions.review_rating,
    actions.review_title_like,
    actions.page,
    actions.filter_hidden,
    actions.filter_media,
  );

  if (response) {
    yield put({
      type: types.GET_LIST_REVIEW_CUSTOMER_SAY_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getCountReviews() {
  const response = yield call(Service.getCountReviews);

  if (response) {
    yield put({
      type: types.GET_COUNT_REVIEW_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getDetailProductReviews(actions) {
  const response = yield call(Service.getDetailProductReviews, actions.id);
  if (response) {
    yield put({
      type: types.GET_DETAIL_REVIEW_RESULT,
      payload: { res: response, id: actions.id },
    });
  } else {
    console.log(response);
  }
}

export function* changeStatusReview(actions) {
  const response = yield call(
    Service.changeStatusReview,
    actions.product_id,
    actions.email,
    actions.status,
  );
  if (response.success) {
    yield put({
      type: types.CHANGE_STATUS_REVIEW_RESULT,
      payload: { res: 1, status: actions.status },
    });
    yield put({ type: types.GET_LIST_REVIEW });
  } else {
    yield put({
      type: types.CHANGE_STATUS_REVIEW_RESULT,
      payload: { res: 2, status: actions.status },
    });
  }
}

export function* sendProductReviewComment(actions) {
  const response = yield call(
    Service.sendProductReviewComment,
    actions.product_id,
    actions.email,
    actions.comment_author,
    actions.comment_email,
    actions.comment_message,
  );
  if (response.success) {
    yield put({
      type: types.SEND_PRODUCT_REVIEW_COMMENT_RESULT,
      payload: { res: 1, actions },
    });
  } else {
    yield put({
      type: types.SEND_PRODUCT_REVIEW_COMMENT_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* editReviewComment(actions) {
  const response = yield call(
    Service.editReviewComment,
    actions.product_id,
    actions.email,
    actions.comment_author,
    actions.comment_email,
    actions.comment_message,
    actions.comment_id,
  );
  if (response.success) {
    yield put({
      type: types.EDIT_REVIEW_COMMENT_RESULT,
      payload: { res: 1, actions },
    });
    yield put({ type: types.GET_LIST_REVIEW });
  } else {
    yield put({
      type: types.EDIT_REVIEW_COMMENT_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* deleteReviewComment(actions) {
  const response = yield call(
    Service.deleteReviewComment,
    actions.product_id,
    actions.email,
    actions.comment_id,
  );
  if (response.success) {
    yield put({
      type: types.DELETE_REVIEW_COMMENT_RESULT,
      payload: { res: 1 },
    });
    yield put({ type: types.GET_LIST_REVIEW });
  } else {
    yield put({
      type: types.DELETE_REVIEW_COMMENT_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* deleteReview(actions) {
  const response = yield call(
    Service.deleteReview,
    actions.product_id,
    actions.email,
  );
  if (response.success) {
    yield put({
      type: types.DELETE_REVIEW_RESULT,
      payload: { res: 1 },
    });
  } else {
    yield put({
      type: types.DELETE_REVIEW_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* deleteMultipReview(actions) {
  const response = yield call(Service.deleteMultipReview, actions.id);
  if (response.success) {
    yield put({
      type: types.DELETE_MULTI_REVIEW_RESULT,
      payload: { res: 1 },
    });
  } else {
    yield put({
      type: types.DELETE_REVIEW_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* getSettings() {
  const response = yield call(Service.getSettings);
  if (response) {
    yield put({
      type: types.GET_SETTINGS_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* updateSettings(actions) {
  const response = yield call(Service.updateSettings, actions.param);
  if (response.success) {
    yield put({
      type: types.UPDATE_SETTINGS_RESULT,
      payload: { res: 1, actions },
    });
  } else {
    yield put({
      type: types.UPDATE_SETTINGS_RESULT,
      payload: { res: 2, actions },
    });
  }
}

export function* exportExcel() {
  const response = yield call(Service.exportExcel);
  if (response.success) {
    yield put({
      type: types.EXPORT_FILE_EXCEL_RESULT,
      payload: response,
    });
  } else {
    console.log(typeof response);
  }
}

export function* importExcel(actions) {
  const response = yield call(
    Service.importExcel,
    actions.csv_file,
    actions.list_handle,
  );
  if (response.processing) {
    yield put({
      type: types.IMPORT_FILE_EXCEL_RESULT,
      payload: response.processing,
    });
  } else {
    yield put({
      type: types.IMPORT_FILE_EXCEL_RESULT,
      payload: response.processing,
    });
  }
}

export function* changeAdminReadAt(actions) {
  const response = yield call(
    Service.changeAdminReadAt,
    actions.product_id,
    actions.email,
  );
  if (response.success) {
    yield put({
      type: types.CHANGE_ADMIN_READ_AT_RESULT,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* getSettingShopInfo() {
  const response = yield call(Service.getSettings);
  if (response) {
    yield put({
      type: types.RESULT_GET_SETTING_SHOP_INFO,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getShopInfoSaga(payload) {
  const response = yield call(Service.getShopInfoService, payload.shop);
  if (response) {
    yield put({
      type: types.GET_SHOP_INFO_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getFormEmailReview() {
  const response = yield call(Service.getFormEmailReview);
  if (response) {
    yield put({
      type: types.GET_FORM_EMAIL_REVIEW_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getFormEmailReviewComment() {
  const response = yield call(Service.getFormEmailReviewComment);
  if (response) {
    yield put({
      type: types.GET_FORM_EMAIL_REVIEW_COMMENT_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getFormEmailReviewOrder() {
  const response = yield call(Service.getFormEmailReviewOrderService);
  if (response) {
    yield put({
      type: types.GET_FORM_EMAIL_REVIEW_ORDER_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getStatusFormEmailReview() {
  const response = yield call(Service.getStatusFormEmailReview);
  if (response) {
    yield put({
      type: types.GET_STATUS_FORM_EMAIL_REVIEW_RESULT,
      payload: response.on_off_sendmail,
    });
  } else {
    console.log(response);
  }
}

export function* getStatusFormEmailReviewComment() {
  const response = yield call(Service.getStatusFormEmailReviewComment);
  if (response) {
    yield put({
      type: types.GET_STATUS_FORM_EMAIL_REVIEW_COMMENT_RESULT,
      payload: response.on_off_sendmail,
    });
  } else {
    console.log(response);
  }
}

export function* getStatusFormEmailReviewOrder() {
  const response = yield call(Service.getFormEmailReviewOrderService);
  if (response) {
    yield put({
      type: types.GET_STATUS_FORM_EMAIL_REVIEW_ORDER_RESULT,
      payload: response.on_off_sendmail,
    });
  } else {
    console.log(response);
  }
}

export function* callSaveCampaign(actions) {
  const response = yield call(Service.callSaveCampaign, actions.payload);
  if (response.success) {
    yield put({
      type: types.RESULT_SAVE_CAMPAIGN,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* changeActiveFormReview(actions) {
  const response = yield call(
    Service.changeActiveFormReview,
    actions.on_off_sendmail,
  );
  if (response.success) {
    yield put({
      type: types.CHANGE_ACTIVE_FORM_REVIEW_RESULT,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* changeActiveFormReviewComment(actions) {
  const response = yield call(
    Service.changeActiveFormReviewComment,
    actions.on_off_sendmail,
  );
  if (response.success) {
    yield put({
      type: types.CHANGE_ACTIVE_FORM_REVIEW_COMMENT_RESULT,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* changeActiveFormReviewOrder(actions) {
  const response = yield call(
    Service.changeActiveFormReviewOrder,
    actions.on_off_sendmail,
  );
  if (response.success) {
    yield put({
      type: types.CHANGE_ACTIVE_FORM_REVIEW_ORDER_RESULT,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* sendTestEmail(actions) {
  const response = yield call(Service.sendTestEmail, actions.param);
  if (response.success) {
    yield put({
      type: types.SEND_TEST_EMAIL_RESULT,
      payload: response.success,
    });
  } else {
    console.log(response);
  }
}

export function* getStatisticBar(actions) {
  const response = yield call(Service.getStatisticBar, actions.param);
  if (response) {
    yield put({
      type: types.GET_STATISTIC_BAR_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListNotificationSaga(data) {
  const response = yield call(
    Notification.getListNotificationService,
    data.shop,
  );
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getNotificationDetailSaga(data) {
  const response = yield call(
    Notification.getNotificationDetailService,
    data.shop,
    data.id,
  );
  if (response) {
    yield put({
      type: types.GET_NOTIFICATION_DETAIL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* updateNotificationSaga(data) {
  const response = yield call(
    Notification.updateNotificationService,
    data.shop,
    data.id,
  );
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION,
      shop: data.shop,
    });
  } else {
    console.log(response);
  }
}

export function* getStatisticRating(actions) {
  const response = yield call(Service.getStatisticRating, actions.param);
  if (response) {
    yield put({
      type: types.GET_STATISTIC_RATING_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListLogEmail() {
  const response = yield call(Service.getListLogEmail);
  if (response) {
    yield put({
      type: types.GET_LIST_LOG_EMAIL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getStatisticCountTotal() {
  const response = yield call(Service.getStatisticCountTotal);
  if (response) {
    yield put({
      type: types.GET_STATISTIC_COUNT_TOTAL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getStatisticEmail() {
  const response = yield call(Service.getStatisticEmail);
  if (response) {
    yield put({
      type: types.GET_STATISTIC_EMAIL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListProduct(actions) {
  const response = yield call(Service.getListProduct, actions.param);
  if (response) {
    yield put({
      type: types.GET_LIST_PRODUCT_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListProductSearch(actions) {
  const response = yield call(Service.getListProductSearch, actions.param);
  if (response) {
    yield put({
      type: types.GET_LIST_PRODUCT_SEARCH_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getRateProduct(actions) {
  const response = yield call(Service.getRateProduct, actions.param);
  if (response) {
    yield put({
      type: types.GET_RATE_PRODUCT_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getContentLogEmail(actions) {
  const response = yield call(Service.getContentLogEmail, actions.id);
  if (response) {
    yield put({
      type: types.GET_CONTENT_LOG_EMAIL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListEmailVerify() {
  const response = yield call(Service.getListEmailVerify);
  if (response) {
    yield put({
      type: types.GET_LIST_EMAIL_VERIFY_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListBlog(actions) {
  const response = yield call(Service.getListBlog, actions.number);
  if (response) {
    yield put({
      type: types.GET_LIST_BLOG_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getCountTotalProduct() {
  const response = yield call(Service.getCountTotalProduct);
  if (response) {
    yield put({
      type: types.GET_COUNT_TOTAL_PRODUCT_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getRandomProduct() {
  const response = yield call(Service.getRandomProduct);
  if (response) {
    yield put({
      type: types.GET_RANDOM_PRODUCT_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* hiddenReview(actions) {
  const response = yield call(Service.hiddenReview, actions.param);
  if (response) {
    yield put({
      type: types.HIDDEN_REVIEW_RESULT,
    });
    yield put({ type: types.GET_LIST_REVIEW });
  } else {
    console.log(response);
  }
}

export function* changeStatusPopupReview(actions) {
  const response = yield call(Service.changeStatusPopupReview, actions.param);
  if (response) {
    yield put({
      type: types.CHANGE_STATUS_POPUP_REVIEW_RESULT,
      payload: actions.param,
    });
  } else {
    console.log(response);
  }
}

export function* getSettingsPopupReview() {
  const response = yield call(Service.getSettingsPopupReview);
  if (response) {
    yield put({
      type: types.GET_SETTINGS_POPUP_REVIEW_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* saveSettingsPopupReview(actions) {
  const response = yield call(Service.saveSettingsPopupReview, actions.param);
  if (response) {
    yield put({
      type: types.SAVE_SETTINGS_POPUP_REVIEW_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* changeStatusGoogleSnippet(actions) {
  const response = yield call(
    Service.changeStatusGoogleSnippet,
    actions.payload,
  );
  if (response) {
    yield put({
      type: types.CHANGE_STATUS_GOOGLE_SNIPPET_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getSettingsGoogleSnippet() {
  const response = yield call(Service.getSettingsGoogleSnippet);
  if (response) {
    yield put({
      type: types.GET_SETTINGS_GOOGLE_SNIPPET_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* changeStatusCustomerSay(actions) {
  const response = yield call(Service.changeStatusCustomerSay, actions.payload);
  if (response.success) {
    yield put({
      type: types.CHANGE_STATUS_CUSTOMER_SAY_RESULT,
      payload: actions.payload,
    });
  } else {
    console.log(response);
  }
}

export function* getSettingsCustomerSay() {
  const response = yield call(Service.getSettingsCustomerSay);
  if (response) {
    yield put({
      type: types.GET_SETTINGS_CUSTOMER_SAY_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* saveCustomerSaySettings(actions) {
  const response = yield call(Service.saveCustomerSaySettings, actions.params);
  if (response.success) {
    yield put({
      type: types.SAVE_CUSTOMER_SAY_SETTINGS_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* resetCustomerSaySettings(actions) {
  const response = yield call(Service.saveCustomerSaySettings, actions.payload);
  if (response.success) {
    yield put({
      type: types.RESET_CUSTOMER_SAY_SETTINGS_RESULT,
      payload: actions.payload,
    });
  } else {
    console.log(response);
  }
}

export function* getListDetailByHandles(actions) {
  const response = yield call(Service.getListDetailByHandles, actions.params);
  if (response) {
    yield put({
      type: types.GET_LIST_DETAIL_BY_HANDLES_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* sagaGetListCustomerSayById({ list_id }) {
  const response = yield call(Service.getListCustomerSayById, list_id);
  if (response) {
    yield put({
      type: types.GET_LIST_CUSTOMER_SAY_BY_ID_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

function* AppSaga() {
  yield takeEvery(types.CHANGE_APP_STATUS, changeAppStatusSaga);
  yield takeEvery(types.GET_LIST_REVIEW, getListProductReviews);
  yield takeEvery(types.GET_DETAIL_REVIEW, getDetailProductReviews);
  yield takeEvery(types.CHANGE_STATUS_REVIEW, changeStatusReview);
  yield takeEvery(types.SEND_PRODUCT_REVIEW_COMMENT, sendProductReviewComment);
  yield takeEvery(types.EDIT_REVIEW_COMMENT, editReviewComment);
  yield takeEvery(types.DELETE_REVIEW_COMMENT, deleteReviewComment);
  yield takeEvery(types.DELETE_REVIEW, deleteReview);
  yield takeEvery(types.DELETE_MULTI_REVIEW, deleteMultipReview);
  yield takeEvery(types.GET_SETTINGS, getSettings);
  yield takeEvery(types.UPDATE_SETTINGS, updateSettings);
  yield takeEvery(types.EXPORT_FILE_EXCEL, exportExcel);
  yield takeEvery(types.IMPORT_FILE_EXCEL, importExcel);
  yield takeEvery(types.GET_COUNT_REVIEW, getCountReviews);
  yield takeEvery(types.CHANGE_ADMIN_READ_AT, changeAdminReadAt);
  yield takeEvery(types.GET_SETTING_SHOP_INFO, getSettingShopInfo);
  yield takeEvery(types.GET_FORM_EMAIL_REVIEW, getFormEmailReview);
  yield takeEvery(
    types.GET_FORM_EMAIL_REVIEW_COMMENT,
    getFormEmailReviewComment,
  );
  yield takeEvery(types.GET_FORM_EMAIL_REVIEW_ORDER, getFormEmailReviewOrder);
  yield takeEvery(types.GET_STATUS_FORM_EMAIL_REVIEW, getStatusFormEmailReview);
  yield takeEvery(
    types.GET_STATUS_FORM_EMAIL_REVIEW_COMMENT,
    getStatusFormEmailReviewComment,
  );
  yield takeEvery(
    types.GET_STATUS_FORM_EMAIL_REVIEW_ORDER,
    getStatusFormEmailReviewOrder,
  );
  yield takeEvery(types.SAVE_CAMPAIGN, callSaveCampaign);
  yield takeEvery(types.CHANGE_ACTIVE_FORM_REVIEW, changeActiveFormReview);
  yield takeEvery(
    types.CHANGE_ACTIVE_FORM_REVIEW_COMMENT,
    changeActiveFormReviewComment,
  );
  yield takeEvery(
    types.CHANGE_ACTIVE_FORM_REVIEW_ORDER,
    changeActiveFormReviewOrder,
  );
  yield takeEvery(types.SEND_TEST_EMAIL, sendTestEmail);
  yield takeEvery(types.GET_SHOP_INFO, getShopInfoSaga);
  yield takeEvery(types.GET_STATISTIC_BAR, getStatisticBar);
  yield takeEvery(types.GET_LIST_NOTIFICATION, getListNotificationSaga);
  yield takeEvery(types.GET_NOTIFICATION_DETAIL, getNotificationDetailSaga);
  yield takeEvery(types.GET_STATISTIC_RATING, getStatisticRating);
  yield takeEvery(types.GET_LIST_LOG_EMAIL, getListLogEmail);
  yield takeEvery(types.GET_STATISTIC_COUNT_TOTAL, getStatisticCountTotal);
  yield takeEvery(types.UPDATE_NOTIFICATION, updateNotificationSaga);
  yield takeEvery(types.GET_STATISTIC_EMAIL, getStatisticEmail);
  yield takeEvery(types.GET_LIST_PRODUCT, getListProduct);
  yield takeEvery(types.GET_RATE_PRODUCT, getRateProduct);
  yield takeEvery(types.GET_CONTENT_LOG_EMAIL, getContentLogEmail);
  yield takeEvery(types.GET_LIST_EMAIL_VERIFY, getListEmailVerify);
  yield takeEvery(types.GET_LIST_BLOG, getListBlog);
  yield takeEvery(types.GET_COUNT_TOTAL_PRODUCT, getCountTotalProduct);
  yield takeEvery(types.GET_RANDOM_PRODUCT, getRandomProduct);
  yield takeEvery(types.HIDDEN_REVIEW, hiddenReview);
  yield takeEvery(types.CHANGE_STATUS_POPUP_REVIEW, changeStatusPopupReview);
  yield takeEvery(types.GET_SETTINGS_POPUP_REVIEW, getSettingsPopupReview);
  yield takeEvery(types.SAVE_SETTINGS_POPUP_REVIEW, saveSettingsPopupReview);
  yield takeEvery(types.GET_LIST_PRODUCT_SEARCH, getListProductSearch);
  yield takeEvery(
    types.CHANGE_STATUS_GOOGLE_SNIPPET,
    changeStatusGoogleSnippet,
  );
  yield takeEvery(types.GET_SETTINGS_GOOGLE_SNIPPET, getSettingsGoogleSnippet);
  yield takeEvery(types.CHANGE_STATUS_CUSTOMER_SAY, changeStatusCustomerSay);
  yield takeEvery(types.GET_SETTINGS_CUSTOMER_SAY, getSettingsCustomerSay);
  yield takeEvery(types.GET_LIST_REVIEW_CUSTOMER_SAY, getListReviewCustomerSay);
  yield takeEvery(types.SAVE_CUSTOMER_SAY_SETTINGS, saveCustomerSaySettings);
  yield takeEvery(types.GET_LIST_DETAIL_BY_HANDLES, getListDetailByHandles);
  yield takeEvery(types.RESET_CUSTOMER_SAY_SETTINGS, resetCustomerSaySettings);
  yield takeEvery(
    types.GET_LIST_CUSTOMER_SAY_BY_ID,
    sagaGetListCustomerSayById,
  );
}

export default AppSaga;
